import React from 'react';

const RegisterPeriod = () => (
  <div>
    <p>Register Period Here</p>
  </div>
);

export default RegisterPeriod;
